import React from 'react';
import Courses from '../Courses/Courses';

const Home = () => {
    return (
        <div>
            <Courses></Courses>
        </div>
    );
};

export default Home;